import { CatalogItems } from '@/entities/catalog-page/CatalogItems/ui/CatalogItems.jsx'
import './ui/CatalogItems.scss'
export default CatalogItems
